import { computed, createApp, defineComponent, h } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import 'remixicon/fonts/remixicon.css';
import './tailwind.css';
import './styles/workbench.css';
import App from './App.vue';
import router from './router';
import { registerLoadingButton } from '@design-system/loading-button';
import { startRealtimeDispatcher } from './stores/realtimeDispatcher';
import { useNotificationStore } from './stores/notification.store';
import { useWorkspaceThemeStore } from './stores/workspace-theme.store';
import ApiAvatar from './components/system/ApiAvatar.vue';
import AppTooltip from './components/system/AppTooltip';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App).use(pinia).use(router).use(Antd);
// 账号、Agent 和商店头像共用 Ant Design 的渲染行为与资源地址解析。
app.component('AAvatar', ApiAvatar);
app.component('ATooltip', AppTooltip);
registerLoadingButton(app, { computed, defineComponent, h });

useNotificationStore(pinia);
useWorkspaceThemeStore(pinia);
startRealtimeDispatcher();
app.mount('#app');
